import { AxiosResponse } from 'axios';
import $api from './instance';

// === ТИПИ ===

// Універсальний тип для довідників, оскільки структура може відрізнятися
export type Dictionaries = any;

// Типи для довідника платежів (залишаємо для типізації там, де він використовується)
export interface PropertyDictionaryItem {
  id: number;
  name: string;
}

export interface TenantDictionaryItem {
  id: number;
  name: string;
}

export interface PeriodDictionaryItem {
  value: string;
  label: string;
}

export interface PaymentTypeDictionaryItem {
  id: string;
  name: string;
}

export interface PaymentDictionariesResponse {
  properties: PropertyDictionaryItem[];
  tenants: TenantDictionaryItem[];
  periods: PeriodDictionaryItem[];
  paymentTypes: PaymentTypeDictionaryItem[];
}

export interface PropertyTypeDictionaryItem {
    value: string;
    label: string;
}

export interface PropertyDictionariesResponse {
    propertyTypes: PropertyTypeDictionaryItem[];
}

// === DICTIONARIES API ===

/**
 * Отримати довідники за назвою
 * GET /dictionaries/:name
 */
export async function getDictionariesRequest<T = Dictionaries>(
  dictionaryName: string,
): Promise<AxiosResponse<T>> {
  return $api.get<T>(`/dictionaries/${dictionaryName}`);
}

/**
 * Get property dictionaries
 * GET /dictionaries/property
 */
export const getPropertyDictionaries = () => {
    return getDictionariesRequest<PropertyDictionariesResponse>('property');
};
